import { useNavigate } from "react-router-dom";

import useAuth from "hooks/useAuth";
import useExecuteMutation from "hooks/useExecuteMutation";

import { OKTA_AUTH_MUTATION } from "graphqlQueries/auth";
import { oktaAuthMapper } from "graphqlQueries/auth.map";

export default function useIAM() {
  const { signIn } = useAuth();
  const navigate = useNavigate();

  const { executeMutation, loading: loginLoading } = useExecuteMutation(
    OKTA_AUTH_MUTATION,
    {
      onSuccessMessage: "Login with Okta successful",
    },
  );

  const onLogin = async (data) => {
    const response = await executeMutation(data);
    if (response?.formErrors) {
      return;
    }
    navigate("/");
    signIn(oktaAuthMapper(response));
  };

  const loginWithIamIfQueryWithAuth = () => {
    const authRedirectRegex = /okta_auth\?(code=[^&]+&state=[^&]+)/;
    const isMatch = window.location.href.match(authRedirectRegex);
    if (isMatch) {
      isMatch[1] &&
        onLogin(Object.fromEntries(new URLSearchParams(isMatch[1])));
    }
  };

  return { loginWithIamIfQueryWithAuth, loginLoading };
}
